import React, { useEffect, useState } from 'react';
import { api } from '../../../services/api';
import { parseSupportMessageMedia } from '../../../utils/supportMessageMedia';

interface SupportMessageMediaGalleryProps {
  contentAttributes?: string | null;
  conversationId?: string;
  messageId?: string;
}

export const SupportMessageMediaGallery: React.FC<SupportMessageMediaGalleryProps> = ({
  contentAttributes,
  conversationId,
  messageId,
}) => {
  const media = parseSupportMessageMedia(contentAttributes);
  const [urls, setUrls] = useState<Record<number, string>>({});

  useEffect(() => {
    if (!conversationId || !messageId || media.length === 0)
    {
      return;
    }

    let cancelled = false;
    setUrls({});
    void (async () => {
      const next: Record<number, string> = {};
      await Promise.all(media.map(async (item, index) => {
        if (!item.objectKey)
        {
          return;
        }

        try
        {
          const response = await api.get<{ url: string }>(
            `/conversations/${conversationId}/messages/${messageId}/media/${index}`
          );
          if (response.data?.url)
          {
            next[index] = response.data.url;
          }
        }
        catch
        {
          // O texto de erro do anexo cobre a falha de URL.
        }
      }));

      if (!cancelled)
      {
        setUrls(next);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [conversationId, messageId, contentAttributes]);

  if (media.length === 0)
  {
    return null;
  }

  return (
    <div className="mb-2 flex flex-col gap-2">
      {media.map((item, index) => {
        const url = urls[index];
        const isImage = (item.contentType || '').toLowerCase().startsWith('image/');
        if (item.error && !url)
        {
          return (
            <p key={index} className="text-sm opacity-80">
              {item.error}
            </p>
          );
        }

        if (!url)
        {
          return (
            <p key={index} className="text-sm opacity-70">
              {item.fileName || 'Anexo'}
            </p>
          );
        }

        if (isImage)
        {
          return (
            <img
              key={index}
              src={url}
              alt={item.fileName || 'Anexo'}
              className="max-h-64 max-w-full rounded-lg object-contain"
            />
          );
        }

        return (
          <a
            key={index}
            href={url}
            target="_blank"
            rel="noreferrer"
            className="text-sm underline"
          >
            {item.fileName || 'Abrir anexo'}
          </a>
        );
      })}
    </div>
  );
};
